var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemarks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M7.034 7.228H2.561c-.984 0-1.79.78-1.79 1.735v6.073c0 .954.806 1.735 1.79 1.735h8.052l2.684 2.602v-6.94"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19.559 10.699h-8.052L8.823 13.3V2.891c0-.954.805-1.735 1.79-1.735h8.946c.984 0 1.79.78 1.79 1.735v6.073c0 .954-.806 1.735-1.79 1.735"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12.402 5.928a.44.44 0 0 0 .448-.434.44.44 0 0 0-.448-.434.44.44 0 0 0-.447.434c0 .24.2.434.447.434M15.086 5.928a.44.44 0 0 0 .447-.434.44.44 0 0 0-.447-.434.44.44 0 0 0-.447.434c0 .24.2.434.447.434M17.77 5.928a.44.44 0 0 0 .447-.434.44.44 0 0 0-.447-.434.44.44 0 0 0-.448.434c0 .24.2.434.448.434"
})));
export default SvgRemarks;